import { render, staticRenderFns } from "./BaseUploadFile.vue?vue&type=template&id=30744fd7&scoped=true&"
import script from "./BaseUploadFile.vue?vue&type=script&lang=js&"
export * from "./BaseUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadFile.vue?vue&type=style&index=0&id=30744fd7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30744fd7",
  null
  
)

export default component.exports